import React from 'react';

/**
 * Single source of truth for angle view options across all tools.
 * Items with `group: true` are non-clickable group headers.
 * Items with `value` are selectable options.
 */
const angleViewGroups = [
  { group: true, label: 'Straight-On Views' },
  { value: 'Straight-On Eye-Level View', label: 'Straight-On Eye-Level View' },
  { value: 'Straight-On Elevated View', label: 'Straight-On Elevated View' },
  { value: 'Straight-On Low-Angle View', label: 'Straight-On Low-Angle View' },
  { group: true, label: 'Corner & Diagonal Views' },
  { value: 'Corner View at Eye Level', label: 'Corner View at Eye Level' },
  { value: 'Corner View Elevated', label: 'Corner View Elevated' },
  { value: 'Corner View Low Angle', label: 'Corner View Low Angle' },
  { group: true, label: 'Overhead Views' },
  { value: "Bird's-Eye Angled View (45°)", label: "Bird's-Eye Angled View (45°)" },
  { value: 'Top-Down Flat View (90°)', label: 'Top-Down Flat View (90°)' },
  { group: true, label: 'Detail & Vignette Views' },
  { value: 'Styled Vignette', label: 'Styled Vignette' },
  { value: 'Close-Up Detail', label: 'Close-Up Detail' },
  { group: true, label: 'Framed & Creative Views' },
  { value: 'Through-Doorway View', label: 'Through-Doorway View' },
  { value: 'Upward Ceiling View', label: 'Upward Ceiling View' },
  { value: 'Window-Framed View', label: 'Window-Framed View' },
];

/**
 * Flat list of selectable angle view values (for system prompts and validation).
 */
export const angleViewValues = angleViewGroups
  .filter((item) => !item.group)
  .map((item) => item.value);

/**
 * Renders <option> elements for a <select> dropdown with non-selectable group headers.
 */
export const renderAngleViewOptions = () => {
  return angleViewGroups.map((item, idx) => {
    if (item.group) {
      return (
        <option key={`group-${idx}`} disabled className="font-bold text-white/40 bg-gray-900">
          {'— ' + item.label + ' —'}
        </option>
      );
    }
    return (
      <option key={item.value} value={item.value} className="bg-gray-900">
        {item.label}
      </option>
    );
  });
};

export default angleViewGroups;
